export const MY_DOCUMENTS_DEFAULT_ITEMS_PER_PAGE = 20;

export const MY_AUGMENTATIONS_DEFAULT_ITEMS_PER_PAGE = 20;

export const MY_PROVENANCE_DEFAULT_ITEMS_PER_PAGE = 24;
